import { hotRank, tickerItems, type HotItem } from '@/mocks/guaHome';

const flagStyle: Record<HotItem['flag'], { label: string; cls: string }> = {
  hot: { label: '爆', cls: 'bg-red-600 text-white' },
  new: { label: '新', cls: 'bg-emerald-500 text-white' },
  up: { label: '↑', cls: 'bg-amber-100 text-amber-700' },
  flat: { label: '—', cls: 'bg-stone-100 text-stone-500' },
};

function formatHeat(n: number) {
  return (n / 1000).toFixed(1) + 'w';
}

export default function HotRank() {
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <section id="hot" className="scroll-mt-20 bg-[#f8f4ec]">
      {/* ticker strip */}
      <div className="border-y border-stone-200/80 bg-gradient-to-r from-red-50 via-amber-50 to-orange-50">
        <div className="mx-auto flex max-w-7xl items-center gap-4 overflow-hidden px-4 py-3 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-red-600 px-3 py-1 text-xs font-bold text-white">
            <i className="ri-radio-2-line" />
            滚动补录
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-ticker flex w-max items-center gap-10">
              {doubled.map((t, i) => (
                <span key={i} className="flex items-center gap-2 whitespace-nowrap text-sm text-stone-600">
                  <i className="ri-sparkling-2-line text-red-400" />
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-8 items-center rounded-full bg-red-600/10 px-3 text-xs font-bold tracking-widest text-red-600">02 · 热榜</span>
              <span className="text-xs font-medium tracking-widest text-stone-400 uppercase">Trending</span>
            </div>
            <h2 className="font-serif-sc mt-3 text-2xl font-bold text-stone-900 md:text-3xl">今日热度 · 一榜看清</h2>
          </div>
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1.5 text-xs text-stone-400">
              <i className="ri-timer-line" /> 热力为近 24h 综合值
            </span>
            <a
              href="#archive"
              className="flex items-center gap-1 whitespace-nowrap rounded-full border border-stone-300 bg-white px-4 py-2 text-sm font-medium text-stone-700 transition-colors hover:border-red-400 hover:text-red-600"
            >
              按题材分流
              <i className="ri-arrow-right-s-line" />
            </a>
          </div>
        </div>

        <div className="mt-8 grid gap-4 lg:grid-cols-2">
          {hotRank.map((it) => {
            const f = flagStyle[it.flag];
            return (
              <a
                key={it.no}
                href="#featured"
                className="group flex items-center gap-4 rounded-2xl border border-stone-200/80 bg-white p-4 transition-all hover:-translate-y-0.5 hover:border-red-300"
              >
                <div
                  className={`flex h-11 w-11 shrink-0 items-center justify-center font-serif-sc text-lg font-black ${
                    it.no <= 3 ? 'bg-gradient-to-br from-red-600 to-orange-500 text-white' : 'bg-stone-100 text-stone-500'
                  }`}
                  style={{ borderRadius: 12 }}
                >
                  {String(it.no).padStart(2, '0')}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="truncate text-[15px] font-bold text-stone-900 transition-colors group-hover:text-red-600">
                      {it.title}
                    </span>
                    <span className={`whitespace-nowrap rounded-md px-1.5 py-0.5 text-[10px] font-bold ${f.cls}`}>{f.label}</span>
                  </div>
                  <div className="mt-1.5 flex items-center gap-2 text-xs text-stone-400">
                    <span className="rounded bg-amber-50 px-1.5 py-0.5 font-medium text-amber-700">{it.zone}</span>
                    <span className="truncate">热度 {formatHeat(it.heat)}</span>
                  </div>
                </div>
                <div className="flex shrink-0 flex-col items-end gap-1">
                  <span className={`font-serif-sc text-sm font-black ${it.trend.startsWith('-') ? 'text-stone-400' : 'text-red-500'}`}>
                    {it.trend}
                  </span>
                  <span className="text-[10px] text-stone-400">涨幅</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}